import { db } from "../../../config/firebaseconfig"
import uuid from 'uuid/v1'

export default function saveContentEdit (
  editType, 
  id, 
  contents, 
  itemIdIfPassage, 
  subscribeToPassage
){

  const keys = {
    passage: 'text',
    question: 'question',
    content: 'content',
    audioLink: 'audioLink',
    instructions: 'instructions',
    teacherGuidance: 'teacherGuidance',
    audioTranscript: 'audioTranscript',
    videoLink: 'videoLink',
    videoTranscript: 'videoTranscript',
    imageLink: 'imageLink',
    imageDescription: 'imageDescription',
    videoFeedback: 'videoFeedback',
    videoFeedbackThumbnail: 'videoFeedbackThumbnail',
  }
  const key = keys[editType]
  if (editType === 'passage') {
    if (id) {
      const p1 = db.collection('contentItemPassages').doc(id).set({
        text: contents
      })
      const p2 = db.collection('contentItems').doc(itemIdIfPassage).update({
        passageId: id,
        passage: contents,
      })
      return Promise.all([p1, p2])
    } else {
      id = uuid()
      const p1 = db.collection('contentItemPassages').doc(id).set({
        text: contents
      })
      const p2 = db.collection('contentItems').doc(itemIdIfPassage).update({
        passageId: id,
        passage: contents,
      })
      return Promise.all([p1, p2]).then(() => subscribeToPassage(id))
    }
  } else {
    return db.collection('contentItems').doc(id).update({
      [key]: contents
    })
  }
}


// WEBPACK FOOTER //
// ./src/helpers/content/manageContent/saveContentEdit.js